import { Tag } from "antd";

export const MESSAGE_STATUS = {
  pendente: { label: "Na fila", color: "default" },
  processando: { label: "Processando", color: "processing" },
  concluido: { label: "Concluída", color: "success" },
  falhou: { label: "Falhou", color: "error" },
  recusado: { label: "Recusada pelo modelo", color: "warning" },
  bloqueado_guardrail: { label: "Bloqueada (guardrail)", color: "error" },
};

export const ACTION_STATUS = {
  pendente: { label: "Aguardando confirmação", color: "processing" },
  executada: { label: "Executada", color: "success" },
  cancelada: { label: "Cancelada", color: "default" },
  expirada: { label: "Expirou", color: "warning" },
  falhou: { label: "Falhou", color: "error" },
  desfeita: { label: "Desfeita", color: "purple" },
};

export const CONVERSATION_STATUS = {
  ativa: { label: "Ativa", color: "processing" },
  encerrada: { label: "Encerrada", color: "default" },
};

export const CANAIS = {
  tela: "Tela do app",
  whatsapp: "WhatsApp",
};

export function StatusTag({ status, mapa }) {
  const item = mapa[status] || { label: status, color: "default" };
  return <Tag color={item.color}>{item.label}</Tag>;
}

export function formatUsd(value, casas = 4) {
  if (value === null || value === undefined) return "—";
  return `US$ ${Number(value).toFixed(casas)}`;
}

export function formatNumber(value) {
  if (value === null || value === undefined) return "—";
  return Number(value).toLocaleString("pt-BR");
}
